import {SagaIterator} from "redux-saga";
import {
    call, put, takeLatest, select, Effect, take, fork,
} from "redux-saga/effects";
import {fetchSiteStructure} from "@montana/services/content/content.service";
import {fetchSiteStructureSuccess} from "./site-structure.actions";
import {IMainMenu} from "@montana/models/generated/cms.interface";
import {IStoreState} from "@montana/store/store";
import {ISettingsContainerState} from "../settings/settings";
import {SettingsAction} from "../settings/settings.actions";
import {AppActions} from "../app/app.actions";
import {connectServiceFunctions, selectCurrentUrlLocale} from "../base/base.sagas";

export function* onFetchSiteStructure(): SagaIterator {
    try {
        const settings: ISettingsContainerState = yield select((store: IStoreState) => ({...store.settings}));
        const language: string = yield selectCurrentUrlLocale(settings.language);

        const [cFetchSiteStructure]: any[] = yield connectServiceFunctions(fetchSiteStructure);
        const customerMode = settings.customerMode;
        const response: Response = yield call(cFetchSiteStructure, customerMode, language, settings.market?.marketId);

        if (response.status === 401) {
            throw new Error('Unauthorized of fetching sitestructure');
        }
        if (!response?.ok) {
            throw new Error(`Could not fetch site structure`);
        }

        const structure: IMainMenu = yield call(response.json.bind(response));

        yield put(fetchSiteStructureSuccess(structure));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Could not get site structure!", e);
    }
}

function* initSiteStructure(): IterableIterator<IterableIterator<Effect> | Effect> {
    // For b2b we wait for the user to login before fetching the navigation
    // For b2c we simply get it right away
    /*if (staticSettings.b2b) {
        yield takeLatest(AuthenticationAction.SET_USER, onFetchSiteStructure);
    } else {
        yield takeLatest([SettingsAction.SET_CUSTOMER_MODE, SettingsAction.INIT_SETTINGS], onFetchSiteStructure);
    }*/
    yield takeLatest([SettingsAction.SET_CUSTOMER_MODE, SettingsAction.INIT_SETTINGS], onFetchSiteStructure);
}

export const siteStructureSagas = [
    take(AppActions.INIT),
    fork(initSiteStructure),
]
